export const SET_PATIENTS = 'set_patients'
export const SET_PATIENTS_WITH_CONSENT = 'set_patients_with_consent'
export const SET_PATIENTS_WITHOUT_CONSENT = 'set_patients_without_consent'
export const SHIFT_PATIENT_TO_WITH_CONSENT = 'shift_patient_to_with_consent'
export const RESET_PATIENTS_DASHBOARD = 'reset_dashboard'

export const initialPatientDashboardState: PatientDashboardState = {
  patients: [],
  patientsWithConsent: [],
  patientsWithoutConsent: [],
}
